import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse, errorRequestHandler } from 'utils';

/*
 * THE SHOOTING SECRETARIES (27 Oct 2026). Kept out of the store, like the
 * protests: one panel reads them and holds what it read.
 */
const request = (api, body, params) => dispatch =>
    axios(apiRequestOptions(api, body, { params }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return Promise.reject(error);
        });

const axiosGet = (api, query, params) => dispatch =>
    axios(apiRequestOptions(api, query, { params }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return Promise.reject(error);
        });

/** { assigned: [{ id, secretaryId, name }], candidates: [{ secretaryId, name }] } */
export const fetchShootingSecretaries = competitionId =>
    request(apiPath.SHOOTING_SECRETARY.PANEL, null, { competitionId });

export const assignShootingSecretary = (competitionId, secretaryId) =>
    request(apiPath.SHOOTING_SECRETARY.ASSIGN, {
        competition: '/api/competitions/' + competitionId,
        secretary: '/api/secretaries/' + secretaryId,
    });

export const removeShootingSecretary = assignmentId =>
    request(apiPath.SHOOTING_SECRETARY.REMOVE, null, { id: assignmentId });

/** The category's decision protocol — lines in place order (27 Oct 2026). */
export const fetchDecisionProtocol = (competitionId, categoryId, scope = 'final') =>
    // `scope` — final (bouts + shooting), bouts, shooting.
    axiosGet(apiPath.DECISION_PROTOCOL.GET, { scope }, { competitionId, categoryId });
